import { on } from 'delegated-events'
import { handleValidation } from '@common/validation'

const state = {
  stripe: null,
  paymentForms: {},
}

const toggleSubmit = (submitButton) => {
  submitButton.disabled = !submitButton.disabled
  submitButton.classList.toggle('btn-loading')
}

const handleSubmit = async (e) => {
  e.preventDefault()

  const form = e.target
  const hasPayment = form.id in state.paymentForms
  const isValid = handleValidation(form)
  const submitButton = form.querySelector('[type=submit]')
  toggleSubmit(submitButton)

  if (!isValid) {
    e.preventDefault()
    toggleSubmit(submitButton)
    return
  }

  if (hasPayment) {
    const card = state.paymentForms[form.id].card

    const result = await state.stripe.createToken(card)

    if (result.error) {
      const errorElement = form.querySelector('.card-errors')
      errorElement.textContent = result.error.message
      toggleSubmit(submitButton)
    } else {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'stripeToken')
      hiddenInput.setAttribute('value', result.token.id)
      form.appendChild(hiddenInput)

      form.submit()
    }
  }
}

const calculateAmount = (form) => {
  let amount = 0

  form.querySelectorAll('.qty-field').forEach((el) => {
    const qty = parseInt(el.value)
    const cost = parseInt(el.dataset.cost)

    if (qty > 0) {
      amount += qty * cost
    }
  })

  return amount
}

const handleQty = (e) => {
  const form = e.target.closest('form')
  const amountEl = form.querySelector('.payment-amount span')

  const amount = calculateAmount(form)

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  const normalizedAmount = formatter.format(amount / 100)
  amountEl.textContent = normalizedAmount
}

const setupPayment = async (form) => {
  const paymentField = form.querySelector('.userform-payment-field')
  state.stripe = window.Stripe(paymentField.dataset.stripePubKey)

  const style = {
    base: {
      fontSize: '16px',
      fontFamily: 'filson-soft, sans-serif',
      color: '#415364',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#415364',
      },
    },
    invalid: {
      color: '#b9112a',
    },
  }

  const card = state.stripe.elements().create('card', { style })

  const cardElement = form.querySelector('.card-element')
  card.mount(cardElement)

  card.addEventListener('change', ({ error }) => {
    const displayError = form.querySelector('.card-errors')

    if (error) {
      displayError.textContent = error.message
    } else {
      displayError.textContent = ''
    }
  })

  state.paymentForms[form.id] = {
    card,
  }

  const qtyFields = form.querySelectorAll('.qty-field')

  if (qtyFields.length) {
    const { default: IMask } = await import('imask/esm/imask')
    await import('imask/esm/masked/number')

    qtyFields.forEach((field) => {
      IMask(field, {
        mask: Number,
        scale: 0,
        min: 0,
        max: 100,
      })
    })
  }
}

const setupForm = (form) => {
  const paymentField = form.querySelector('.userform-payment-field')

  if (paymentField) {
    setupPayment(form)
  }
}

document.querySelectorAll('form.userform').forEach((form) => {
  setupForm(form)
})

on('submit', '.styled-form.userform', handleSubmit)
on('blur', '.styled-form.userform .qty-field', handleQty, { capture: true })
